import React, { Component } 	from "react"
import { connect } 				from 'react-redux'
import { post, get } 			from '../../services/apiServices'
import { token } 				from '../../services/authServices'
import { withStyles } 			from 'material-ui/styles'
import { CircularProgress } 	from 'material-ui/Progress'
import ReactPaginate 			from 'react-paginate'
import Icon 					from 'material-ui/Icon'
import Button 					from 'material-ui/Button'
import TextField 				from 'material-ui/TextField'
import Table, {
	TableBody,
	TableCell,
	TableHead,
	TableRow } 					from 'material-ui/Table'
import Dialog, {
	DialogContent,
	DialogActions,
	DialogTitle } 				from 'material-ui/Dialog'

const styles = {
	progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    },
	titleWrap: {
		marginTop: '15px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		color: '#3f51b5'
	},
	tableRow: {
		cursor: 'pointer'
	},
	inputWrap: {
		marginBottom: '20px'
	},
	closeIcon: {
		position: 'absolute',
		top: '10px',
		right: '10px',
		color: '#a9a9a9',
		cursor: 'pointer'
	},
	editIcon: {
		padding: '10px',
		cursor: 'pointer'
	},
	justifyCenter: {
		justifyContent: 'center'
	}
}

class Teachers extends Component {
	constructor(props) {
		super(props)

		this.state = {
			'open' : false,
			'teachers' : this.props.teachers,
			'id' : null,
			'first_name' : '',
			'last_name' : '',
			'email' : '',
			'errors' : null
		}
	}

	getSingleTeacher = id => {
		get(`/admin/accounts/${this.props.accountId}/teachers/${id}`, token).then(res => {
			let response = res.data

			if (response.data) {
				let teacher = response.data

				this.setState({
					'id' : teacher.id,
					'first_name' : teacher.first_name,
					'last_name' : teacher.last_name,
				})

				this.handleToggleModal(true)
			}
		})
	}

	getTeachers = () => {
		this.props.initTeachers(this.props.accountId).then(res => {
			this.setState({'teachers' : this.props.teachers})
		})
	}

	onSubmit = () => {
		const {id, first_name, last_name, email} = this.state
		let teacherId = id ? `/${id}` : ''
		let data = {
			'first_name' : first_name,
			'last_name' : last_name
		}

		if (!teacherId)
			data.email = email

		post(`/admin/accounts/${this.props.accountId}/teachers${teacherId}`, data, token, err => {
			let response = JSON.parse(err._bodyText)

			if (response.errors)
				this.setState({'errors' : response.errors})
		}).then(res => {
			let response = res.data

			if (response.data) {
				this.getTeachers()
				this.handleToggleModal(false)
			}
		})
	}

	handleInputChange = e => {
  	  let state = this.state
  	  state[e.target.name] = e.target.value

  	  this.setState(state)
    }

	handleToggleModal = bool => {
		if (!bool)
			this.setState({
				'id' : null,
				'first_name' : '',
				'last_name' : '',
				'email' : '',
				'errors' : null
			})

		this.setState({'open' : bool})
	}

	handlePageChange = action => {
		this.props.pageChange(this.props.accountId, action.selected + 1).then(res => {
			this.setState({'teachers' : this.props.teachers})
		})
	}

	renderTeachersList = () => {
		let teachers = this.state.teachers.data
		let result = []

		teachers.map(teacher => {
			result.push(
				<TableRow key={teacher.id}>
					<TableCell padding="none">
						{teacher.first_name}
					</TableCell>
					<TableCell padding="none">
						{teacher.last_name}
					</TableCell>
					<TableCell padding="none">
						{teacher.email}
					</TableCell>
					<TableCell padding="none">
						{teacher.updated_at.date}
					</TableCell>
					<TableCell padding="none">
						<Icon
							className={this.classes.editIcon}
							onClick={(e) =>
								this.getSingleTeacher(teacher.id, e)}>
							mode_edit
						</Icon>
					</TableCell>
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	renderPagination = () => {
		let meta = this.state.teachers.meta
		let last_page = meta.last_page
		let current_page = meta.current_page - 1
		let pagination = null

		last_page > 1 ?
			pagination = <ReactPaginate
				previousLabel={<Icon>navigate_before</Icon>}
				nextLabel={<Icon color="primary">navigate_next</Icon>}
				breakLabel={<a href="">...</a>}
				breakClassName={"break-me"}
				pageCount={last_page}
				initialPage={current_page}
				disableInitialCallback= {true}
				marginPagesDisplayed={2}
				pageRangeDisplayed={5}
				onPageChange={this.handlePageChange}
				containerClassName={"pagination"}
				subContainerClassName={"pages pagination"}
				activeClassName={"active"}
			/>
		: null

		return pagination
	}

	componentWillMount() {
		this.getTeachers()
	}

	classes = this.props.classes

	render() {
		const { teachers,
				id,
				first_name,
				last_name,
				email,
				errors } = this.state
		let isFetching = teachers ? teachers.isFetching : true
		let disable = first_name.length < 3 || last_name.length < 3
			|| !id ? !email : false

		return(
			isFetching ?
			<div className={this.classes.progressWrapper}>
				<CircularProgress
					className={this.classes.progress}
					size={50}
				/>
			</div>
			:
			<div>
				<Dialog
					open={this.state.open}
					onClose={() => this.handleToggleModal(false)}>
					<DialogTitle>
						<Icon
							className={this.classes.closeIcon}
							onClick={() => this.handleToggleModal(false)}>
							close
						</Icon>
						{id ? 'Edit' : 'Add'} teacher
					</DialogTitle>
					<DialogContent>
						<div className={this.classes.inputWrap}>
							<TextField
								error={errors ? errors.first_name : false}
								label="First Name"
								name="first_name"
								value={first_name}
								onInput={this.handleInputChange}
								helperText={
									errors && errors.first_name ?
										errors.first_name[0] : ''
								}
							/>
						</div>
						<div className={this.classes.inputWrap}>
							<TextField
								error={errors ? errors.last_name : false}
								label="Last Name"
								name="last_name"
								value={last_name}
								onInput={this.handleInputChange}
								helperText={
									errors && errors.last_name ?
										errors.last_name[0] : ''
								}
							/>
						</div>
						{
							!id ?
							(
								<div className={this.classes.inputWrap}>
									<TextField
										error={errors ? errors.email : false}
										label="Email"
										name="email"
										type="email"
										value={email}
										onInput={this.handleInputChange}
										helperText={
											errors && errors.email ?
												errors.email[0] : ''
										}
									/>
								</div>
						) : null
						}
					</DialogContent>
					<DialogActions className={this.classes.justifyCenter}>
						<Button
							variant="raised"
							color="primary"
							onClick={this.onSubmit}
							disabled={disable}>
							{id ? 'Edit' : 'Add'}
						</Button>
					</DialogActions>
				</Dialog>
				<div className={this.classes.titleWrap}>
					{
						teachers.data && teachers.data.length ?
						<h2 className={this.props.classes.title}>
							Teachers
						</h2>
						:
						<h2>
							Not found
						</h2>
					}
					<Button
						variant="raised"
						color="primary"
						onClick={() => this.handleToggleModal(true)}>
						Add teacher
					</Button>
				</div>
				{
					teachers.data && teachers.data.length ?
					<div>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell padding="none">
										FIRST NAME
									</TableCell>
									<TableCell padding="none">
										LAST NAME
									</TableCell>
									<TableCell padding="none">
										EMAIL
									</TableCell>
									<TableCell padding="none">
										LAST UPDATE
									</TableCell>
									<TableCell padding="none">
										ACTION
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{this.renderTeachersList()}
							</TableBody>
						</Table>
						{this.renderPagination()}
					</div>
					: null
				}
			</div>
		)
	}
}

export default withStyles(styles)(Teachers)



// WEBPACK FOOTER //
// ./src/components/content/Teachers.js